import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: e, disableSSR: m, style: r, ...p }) => {
  const E = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-USDEwakuang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: E, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-USDEæç¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: l ? d(c, 0, "#262933") : "#262933",
        datafollowfill: l ? d(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5 16C5 10.201 9.701 5.5 15.5 5.5S26 10.201 26 16a1 1 0 1 0 2 0c0-6.904-5.596-12.5-12.5-12.5S3 9.096 3 16s5.596 12.5 12.5 12.5a1 1 0 1 0 0-2C9.701 26.5 5 21.799 5 16Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.709 12.736a4.158 4.158 0 0 1 4.049.96 4.158 4.158 0 0 1 1.192 3.988.95.95 0 0 0 1.85.437 6.058 6.058 0 0 0-1.738-5.806 6.058 6.058 0 0 0-5.896-1.4.95.95 0 1 0 .543 1.82Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16.864 14.49a.95.95 0 0 1 .058 1.343l-4.372 4.77a.95.95 0 1 1-1.4-1.285l4.372-4.769a.95.95 0 0 1 1.342-.058ZM24.3 19.4a.8.8 0 0 0-1.6 0v.84h-.834a2.166 2.166 0 0 0 0 4.331h3.268a.566.566 0 1 1 0 1.133H20.95a.8.8 0 0 0 0 1.6h1.75v.839a.8.8 0 1 0 1.6 0v-.84h.834a2.166 2.166 0 0 0 0-4.332h-3.268a.566.566 0 0 1 0-1.132h4.184a.8.8 0 0 0 0-1.6H24.3v-.84Z"
        }
      )
    )
  )));
}, k = x;
export {
  k as default
};
